import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { useStyles } from "app/main/schedules/schedules.styles";
import LoadingTableRow from "../base-table/LoadingTableRow";
import NoDataTableRow from "../base-table/NoDataTableRow";
import { SalesApiResponse, SaleRow } from "app/types/service-types/SalesTypes";
import { SalesTableRow } from "./SalesTableRow";
import { useTranslation } from "react-i18next";
import AppUtils from "../../../utils/AppUtils";

interface IProps {
  rows: SaleRow[];
  loading: boolean;
  response: SalesApiResponse | null;
}

const SaleTable: React.FC<IProps> = ({ rows, loading, response }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const hasData = rows && rows.length > 0;

  return (
    <TableContainer component={Paper}>
      <Table aria-label="sales table">
        <TableHead>
          <TableRow className={classes.root}>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              {t("app.main.sales.bookingDateTime", "Booking Date/Time")}
            </TableCell>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              {t("app.main.sales.bookingNumber", "Booking Number")}
            </TableCell>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              {t("app.main.sales.passangers", "Passenger")}
            </TableCell>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              {t("app.main.sales.departureFlight", "Departure Flight")}
            </TableCell>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              {t("app.main.sales.returnFlight", "Return Flight")}
            </TableCell>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              {t("app.main.sales.departureDate", "Departure Date")}
            </TableCell>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              {t("app.main.sales.returningDate", "Returning Date")}
            </TableCell>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              {t("app.main.sales.departureTicketPrice", "Departure Ticket Price")}
            </TableCell>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              {t("app.main.sales.returnTicketPrice", "Return Ticket Price")}
            </TableCell>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              {t("app.main.sales.seatSelectionCost", "Seat Selection Cost")}
            </TableCell>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              {t("app.main.sales.baggageCost", "Baggage Cost")}
            </TableCell>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              {t("app.main.sales.total", "Total")}
            </TableCell>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              {t("app.main.sales.commission", "Commission (2%)")}
            </TableCell>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              {t("app.main.sales.netAmount", "Net Amount")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <LoadingTableRow colSpan={10} />
          ) : !hasData ? (
            <NoDataTableRow colSpan={10} />
          ) : (
            rows.map((r) => <SalesTableRow key={r.id} row={r} />)
          )}

          {response && hasData && !loading && (
            <TableRow>
              <TableCell colSpan={11} align="right" style={{ fontWeight: "bold" }}>
                {t("app.main.sales.totals", "Totals")}
              </TableCell>

              <TableCell align="center" style={{ fontWeight: "bold" }}>
                {AppUtils.formatMoney(response.totalGrossSales)}
              </TableCell>

              <TableCell align="center" style={{ fontWeight: "bold" }}>
                {AppUtils.formatMoney(response.totalCommission)}
              </TableCell>

              <TableCell align="center" style={{ fontWeight: "bold" }}>
                {AppUtils.formatMoney(response.totalNet)}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SaleTable;
